import { useState, type ReactNode } from "react";
import { settings } from "@/lib/settings";
import { ReviewShell } from "./review-shell";
import { ReviewerNameGate } from "./reviewer-name-gate";

/** Review desk shell with reviewer NameGate. Capture still uses scannerName. */
export function ReviewDesk({ children }: { children: ReactNode }) {
  const [named, setNamed] = useState(() => !!settings.getReviewerName());

  return <ReviewShell>{named ? children : <ReviewerNameGate onSaved={() => setNamed(true)} />}</ReviewShell>;
}
